module.exports = __webpack_public_path__ + "static/media/icon_03.a50fe801.png";